export default {
  site_key: process.env.REACT_APP_RECAPTCHA_KEY,
};
